(function () {
  document.querySelectorAll('[data-sv-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-sv-gallery-track]');
    var slides = gallery.querySelectorAll('[data-sv-gallery-slide]');
    var counter = gallery.querySelector('[data-sv-gallery-counter]');
    var dots = gallery.querySelectorAll('[data-sv-gallery-dot]');

    if (!track || slides.length < 2) return;

    function updateActive() {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      index = Math.max(0, Math.min(index, slides.length - 1));

      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateActive();
        ticking = false;
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });

    window.addEventListener('resize', updateActive);
  });
})();
